// import i18n, { getLanguage } from '@/lang'
import Cookies from 'js-cookie'
// import axios from '@/axios'

// 要设置的全局访问的state对象
const state = {
  language: Cookies.get('language') || 'zh_CN', // 中英文
  retailogMenuHighLight: Cookies.get('retailogMenuHighLight') || 'log/taskManage', // 当前菜单key
  retailogMenuTitle: Cookies.get('retailogMenuTitle') || '全国任务列表', // 当前菜单key
  token: Cookies.get('token') || '', // 用户token
  account: Cookies.get('account') || '', // 用户account
  roleCode: Cookies.get('retailog-roleCode') || '', // 用户roleCode
  isAdmin: Cookies.get('isAdmin') || '', // 用户是否是admin
  isOthers: Cookies.get('isOthers') || '', // 用户是否是others
  isHead: Cookies.get('isHead') || '', // 用户是否是HEADQUARTER
  avatar: Cookies.get('avatar') || '', // 用户头像
  areaList: [], // 区域列表
  provinceList: [], // 省份列表
  cityList: [], // 城市列表
  resellerList: [], // 客户列表
  subResellerList: [], // 二级客户列表
  KeyDoorList: [], // iskeydoor列表
  courseClassList: [], // 品类列表
  roleList: [], // 角色列表
  statusList: [] // 状态列表
}

// 处理同步
const mutations = {
  setToken (state, token) {
    state.token = token
    Cookies.set('token', token)
  },
  setAccount (state, account) {
    state.account = account
    Cookies.set('account', account)
  },
  setAvatar(state, avatar) {
    state.avatar = avatar;
    Cookies.set('avatar', avatar)
  },
  setRoleCode (state, roleCode) {
    state.roleCode = roleCode
    Cookies.set('retailog-roleCode', roleCode)
    console.log('retailog-roleCode', roleCode)
    console.log('retailog-roleCode', state.roleCode)
  },
  setLanguage (state, lang) {
    state.language = lang
    Cookies.set('language', lang)
  },
  setAdmin (state, bool) {
    state.isAdmin = bool
    Cookies.set('isAdmin', bool)
  },
  setOthers (state, bool) {
    state.isOthers = bool
    Cookies.set('isOthers', bool)
  },
  setHead (state, bool) {
    state.isHead = bool
    Cookies.set('isHead', bool)
  },
  setMenuTitle(state, title) {
    state.retailogMenuTitle = title;
    Cookies.set('retailogMenuTitle', title)
  },
  setMenuHighLight(state, title) {
    state.retailogMenuHighLight = title;
    Cookies.set('retailogMenuHighLight', title)
  },
}

// 处理异步
const actions = {
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/topdoor/store/modules/app.js